import mitt from 'mitt';

const emitter = mitt();

export const EventBus = {
    $on(event, handler) {
        emitter.on(event, handler);
    },
    $off(event, handler) {
        emitter.off(event, handler);
    },
    $emit(event, payload) {
        // Ensure the payload is not null or undefined before emitting the event
        if (payload == null) {
            console.warn(`Attempted to emit an event with null or undefined payload for event: ${event}`);
        } else {
            emitter.emit(event, payload);
        }
    }
};